<mat-form-field [hideRequiredMarker]="hideRequiredMarker()">
  <mat-label>{{ label() | translate }}</mat-label>
  <input
    [attr.inputmode]="inputmode()"
    [autocomplete]="autocomplete()"
    [formControl]="accessorDirective.control"
    [id]="id()"
    [placeholder]="showPlaceholder() ? (placeholder() | translate) : null"
    [type]="fieldType()"
    matInput />
  <button (click)="togglePasswordVisibility()" mat-icon-button matSuffix type="button">
    <mat-icon>
      {{ passwordRevealIcon() }}
    </mat-icon>
  </button>

  @if (hint()) {
    <mat-hint>
      {{ hint() | translate }}
    </mat-hint>
  }
  @if (showMatError() && accessorDirective.control.hasError('pattern')) {
    <mat-error>
      {{ 'passwort_meter.rule_description.need_3_of_4' | translate }}
    </mat-error>
  }
  @if (showMatError() && accessorDirective.control.hasError('parenthese')) {
    <mat-error>
      {{ 'passwort_meter.rule_description.parenthese' | translate }}
    </mat-error>
  }

  @if (errors().length > 0) {
    <mat-error>
      @for (error of errors(); track error) {
        @if (showMatError() && accessorDirective.control.hasError(error.errorCode)) {
          <span>{{ error.errorMessage | translate }}</span>
        }
      }
    </mat-error>
  }
</mat-form-field>

@if (createPasswordMode()) {
  <div class="progress-outer">
    <portal-progress-bar
      [value]="accessorDirective.control.value"
      [rules]="passwordRules()?.passwordPolicies ?? []"
      [minimumLength]="passwordRules()?.minimumLength"
      [maximumLength]="passwordRules()?.maximumLength" />
  </div>
}
